import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import { ReturnPrice } from "../../../../components/modules/sales/return-price";
import ReturnPriceMiddleware from "../../../../middleware/modules/sales/return-price";
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
// middlewares
const mapStateToProps = ({ auth, returnPrice }) => ({
  isProcessing: returnPrice.isProcessing,
  isError: returnPrice.isError,
  errorMessage: returnPrice.errorMessage,
  data: returnPrice.data,
  showModal: returnPrice.showModal,
  helperReturnPrice: returnPrice.helperReturnPrice,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      create: () => ReturnPriceMiddleware.create(),
      reset: () => ReturnPriceMiddleware.resetList(),
      approve: (id, value, search) => ReturnPriceMiddleware.beforeApprove(id, value, search),
      reject: (id, value, search) => ReturnPriceMiddleware.beforeReject(id, value, search),
      search: (data) => ReturnPriceMiddleware.list(data),
      update: (data) => ReturnPriceMiddleware.update(data),
      delete: (id, search) => ReturnPriceMiddleware.beforeDelete(id, search),
      getHelperFull: (id, search) =>
        ReturnPriceMiddleware.getHelper(id, search),
    },
    dispatch
  );
};
class ReturnPriceContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.deleteItem = this.deleteItem.bind(this);
    this.createItem = this.createItem.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.approveItem = this.approveItem.bind(this);
    this.rejectItem = this.rejectItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
    this.props.getHelperFull();
  }

  deleteItem(id, search) {
    this.props.delete(id, search);
  }
  updateItem(id) {
    this.props.getHelperFull();
    this.props.update(id);
  }
  createItem() {
    this.props.create();
    this.props.getHelperFull();
  }
  approveItem(id, value, search) {
    this.props.approve(id, value, search);
  }
  rejectItem(id, value, search) {
    this.props.reject(id, value, search);
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Return Price List")}
          </title>
        </Helmet>
      <ReturnPrice
       {...this.props}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
        approveItem={this.approveItem}
        rejectItem={this.rejectItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnPriceContainer);
